import type { EquipmentV2LabelType } from "../../utils/labels";
import { equipmentV2Labels } from "../../utils/labels";
import type { EquipmentV2SettingsActionsType } from "../actions/EquipmentV2SettingsActions";
import { EQUIPMENT_V2_SETTINGS_INIT } from "../actions/EquipmentV2SettingsActions";
import { ContentViewMode } from "../../utils/constants";

export type EquipmentV2SettingsType = {
    initialized: boolean;
    finance: {
        monthlyRateService: string;
        monthlyRateDisclaimerService: string;
        monthlyRateConfigurablesService: string;
        monthlyRateSelectedService: string;
    };
    viewMode: ContentViewMode;
    labels: Record<EquipmentV2LabelType, string>;
};

export const equipmentV2SettingsInitialState: EquipmentV2SettingsType = {
    initialized: false,
    viewMode: ContentViewMode.Thumbs,
    finance: {
        monthlyRateService: "",
        monthlyRateSelectedService: "",
        monthlyRateConfigurablesService: "",
        monthlyRateDisclaimerService: "",
    },
    labels: { ...equipmentV2Labels },
};

const EquipmentV2SettingsReducer = (
    state: EquipmentV2SettingsType = equipmentV2SettingsInitialState,
    action: EquipmentV2SettingsActionsType,
): EquipmentV2SettingsType => {
    switch (action.type) {
        case EQUIPMENT_V2_SETTINGS_INIT: {
            return { ...state, ...action.initState, initialized: true };
        }

        default:
            return state;
    }
};

export default EquipmentV2SettingsReducer;
